<template>
  <el-container style="height: 100%">
    <el-main>
      <div class="container">
        <div class="toolbar" style="background-color: #f7f7f7;">
          <router-link to="/point/new">
            <el-button type="primary"
            @click="onAdd"
            icon0="el-icon-circle-plus-outline"
            style="flex: 0;">
              Nouveau point
            </el-button>
          </router-link>
        </div>
        <div class="list-group" v-if="points.length > 0">
          <router-link v-for="point in points"
          :key="point.id"
          :to="'/point/'+point.id"
          class="list-group-item justify-content-between">
            <span 
            class="title"
            v-html="point.titre"></span>
            <router-link
            class="button"
            :to="'/point/'+point.id">
              <el-button
              size="mini"
              type="primary">
                <icon name="edit"></icon>
              </el-button>
            </router-link>
            <el-button
            class="button"
            type="primary"
            size="mini"
            @click="onDel($event, point)">
              <icon name="trash"></icon>
            </el-button>
          </router-link>
        </div>
      </div>
    </el-main>
  </el-container>
</template>
<script>
export default {
  data () {
    return {
      milieu_id: 0,
      points: []
    }
  },
  activated () {
    this.getMilieuMap()
  },
  mounted () {
    this.getMilieuMap()
  },
  methods: {
    getMilieuMap: function(){
      var vm = this
      this.milieu_id = parseInt(this.$route.params.id)
      this.$http.post(
        global.baseUrl+"admin.php?action=get_milieu_map", {
          milieu_id: this.milieu_id
        })
      .then(function(data){
          var resp = data.body
          if(resp.ok){
            console.log(resp)
            this.background_img_src = resp.milieu.photo_path
            this.points = resp.points
            this.loaded = true
          }
        }, function(data){

        });
    },
    onAdd: function(e){
      console.log(this.$router)
      // this.$http.post(
      //   global.baseUrl+"main.php?action=get_milieu_list", {

      //   },{
      //     emulateJSON: true
      //   })
      // .then(function(data){
      //     var resp = data.body
      //     if(resp.ok){
      //       console.log(resp)
      //       vm.milieux = resp.milieux
      //     }
      //   }, function(data){

      //   });
    },
    onDel: function(e, milieu){

    },
    save: function(){
      var post_data
      var action
      if(this.milieu_id > 0) {
        // post_data = {}
      }

      this.$http.post(
        global.baseUrl+"main.php?action=set_milieu", {
          milieu_id: this.milieu_id,
          title: this.form.title,
          descr: this.form.descr,
        }, 
        {
          emulateJSON: false
        }).then(function(data){
          var resp = data.body
          var new_milieu_id = parseInt(data.body.milieu_id)

          if(this.milieu_id !== new_milieu_id){
            this.$router.replace('/milieu/'+new_milieu_id)
          }
        }, function(data){
      });
    }
  }
}
</script>
<style type="text/css">

</style>